import { Theme, useMediaQuery } from '@material-ui/core';

export const BreakpointThreshold = {
  /**
   * Mobile: ~ 767
   * Tablet: 768 ~ 1279
   * Desktop: 1280 ~
   */
  Mobile: 360,
  Tablet: 768,
  Desktop: 1280,
} as const;

export type CSSValue = string | number | boolean | null;

interface IBreakpoint {
  mobile: boolean;
  tablet: boolean;
  desktop: boolean;
  getMediaQueryValue: <T>(m: CSSValue, t: CSSValue, d: CSSValue) => T;
  getMediaQueryBreak: 'mobile' | 'tablet' | 'desktop';
}

const useBreakpoint = (): IBreakpoint => {
  const options = { noSsr: true };

  const mobile = useMediaQuery((theme: Theme) => theme.breakpoints.down(BreakpointThreshold.Tablet), options);
  const tablet = useMediaQuery((theme: Theme) => theme.breakpoints.down(BreakpointThreshold.Desktop), options);
  const desktop = useMediaQuery((theme: Theme) => theme.breakpoints.up(BreakpointThreshold.Desktop), options);

  // TODO: uncomment if it is needed
  /*
  const mobileOnly = useMediaQuery((theme: Theme) => theme.breakpoints.between(0, BreakpointThreshold.Tablet), options);
  const tabletOnly = useMediaQuery(
    (theme: Theme) => theme.breakpoints.between(BreakpointThreshold.Tablet, BreakpointThreshold.Desktop),
    options
  );
  const desktopOnly = useMediaQuery(
    (theme: Theme) => theme.breakpoints.between(BreakpointThreshold.Desktop, Number.MAX_SAFE_INTEGER),
    options
  );
  */

  const isNotEmpty = (v: any): boolean => v !== null && v !== undefined;

  const getMediaQueryValue = <T>(m: CSSValue, t: CSSValue, d: CSSValue): T =>
    (mobile
      ? isNotEmpty(m)
        ? m
        : isNotEmpty(t)
        ? t
        : d
      : tablet
      ? isNotEmpty(t)
        ? t
        : isNotEmpty(m)
        ? m
        : d
      : d) as unknown as T;

  const getMediaQueryBreak = mobile ? 'mobile' : tablet ? 'tablet' : 'desktop';

  return {
    mobile,
    tablet,
    desktop,
    getMediaQueryValue,
    getMediaQueryBreak,
  };
};

export default useBreakpoint;
